import { JSONSerializable } from '../util/json';
import { Coins } from './Coins';
import { Int } from './numeric';

export class StdFee extends JSONSerializable<StdFee.Data> {
  public readonly amount: Coins;

  constructor(public readonly gas: number, amount: Coins.Input) {
    super();
    this.amount = new Coins(amount);
  }

  public static fromData(data: StdFee.Data): StdFee {
    const { gas, amount } = data;
    return new StdFee(Number.parseInt(gas), Coins.fromData(amount));
  }

  public toData(): StdFee.Data {
    return {
      gas: new Int(this.gas).toString(),
      amount: this.amount.toData(),
    };
  }

  public gasPrices(): Coins {
    return this.amount.toDecCoins().div(this.gas);
  }
}

export namespace StdFee {
  export interface Data {
    gas: string;
    amount: Coins.Data;
  }
}
